/**
 * @class predefined filters
 */

module.exports = {
  skip_server: require('./filters/skip_server.json'),
  skip_box: require('./filters/skip_box.json'),
  skip_gui: require('./filters/skip_gui.json'),
  mask_passwords: require('./filters/mask_passwords.json'),
  mask_binary: require('./filters/mask_binary.json'),
  mask_messages: require('./filters/mask_messages.json'),
  mask_doppler: require('./filters/mask_doppler.json'),
  log_server: require('./filters/log_server.json'),
  log_box: require('./filters/log_box.json'),
  log_gui: require('./filters/log_gui.json'),
  mock: require('./filters/mock.json'),
  mock_doppler: require('./filters/mock_doppler.json'),
  record_filter: require('./filters/record_filter.json'),
  record_repeat: require('./filters/record_repeat.json'),
  player: require('./filters/player.json'),
  doppler: require('./filters/doppler.json'),
  streamer_block_server: require('./filters/streamer_block_server.json'),
  streamer_block_peer: require('./filters/streamer_block_peer.json'),
  streamer_block_remote: require('./filters/streamer_block_remote.json'),
  doppler_relay: require('./filters/doppler_relay.json'),
  doppler_relay_md: require('./filters/doppler_relay_md.json'),
  vascar12: require('./filters/vascar12.json'),
}
